<template>
	<v-card flat class="ma-0">
		<v-form ref="form">
			<h6 class="text-body-1 font-weight-bold mt-2">絞り込み</h6>
			<v-row no-gutters>
				<v-col cols="12" sm="6" lg="4" class="px-1">
					<v-text-field
						label="製造番号"
						v-model="q.ordered_product_product_number_cont"
						class="mt-4"
						outlined
						clearable
						dense
					/>
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="px-1">
					<v-select
						label="製品分類"
						v-model="q.ordered_product_product_product_category_id_eq"
						:items="categories"
						item-text="name"
						item-value="id"
						no-data-text="データがありません"
						class="mt-4"
						outlined
						clearable
						dense
					/>
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="px-1">
					<v-menu
						ref="plannedShippingDateRangeMenu"
						v-model="plannedShippingDateRangeMenu"
						:close-on-content-click="false"
						:return-value.sync="plannedShippingDateRange"
						transition="scale-transition"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="plannedShippingDatesText"
								label="出荷日"
								class="mt-4"
								clearable
								outlined
								dense
								readonly
								v-bind="attrs"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							class="date-picker"
							v-model="plannedShippingDateRange"
							no-title
							scrollable
							range
							locale="ja-JP"
						>
							<v-spacer />
							<v-btn text color="grey" @click="plannedShippingDateRangeMenu = false">
								キャンセル
							</v-btn>
							<v-btn
								text
								color="primary"
								@click="
									changeDateRange('plannedShippingDateRange', 'delivery_info_planned_shipping_date')
								"
							>
								決定
							</v-btn>
						</v-date-picker>
					</v-menu>
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="px-1">
					<v-text-field
						label="製品名"
						v-model="q.ordered_product_product_name_cont"
						class="mt-4"
						outlined
						clearable
						dense
					/>
				</v-col>
				<v-col v-if="!hideStatus" cols="12" sm="6" lg="4" class="px-1">
					<v-select
						label="状態"
						:items="statuses"
						item-text="name"
						item-value="id"
						v-model="q.status_in"
						class="mt-4"
						outlined
						clearable
						dense
					/>
				</v-col>
				<v-col cols="12" sm="6" lg="4" class="mt-4 px-1">
					<v-row no-gutters>
						<v-col cols="6" class="pr-1">
							<v-btn width="100%" @click="searchOrderIndividualInfos" color="secondary">
								<v-icon class="mr-2">mdi-magnify</v-icon>
								検索</v-btn
							>
						</v-col>
						<v-col cols="6" class="pl-1">
							<v-btn width="100%" @click="resetForm" outlined color="secondary">
								<v-icon class="mr-2">mdi-autorenew</v-icon>
								クリア</v-btn
							>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-form>
	</v-card>
</template>

<script>
import common from "../../../helper/common"

export default {
	props: {
		hideStatus: {
			type: Boolean,
			default: false,
		},
		categories: {
			type: Array,
			required: true,
		},
		text: {
			type: Boolean,
			default: false,
		},
		query: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			plannedShippingDateRange: [],
			plannedShippingDateRangeMenu: false,
			dialog: false,
			statuses: [
				{ id: ["manufacture_started"], name: "製造開始" },
				{ id: ["manufacture_completed"], name: "製造完了" },
				{ id: ["order_received"], name: "受注済み" },
			],
			q: {
				status_in: null,
				delivery_info_planned_shipping_date_lteq: null,
				delivery_info_planned_shipping_date_gteq: null,
				ordered_product_product_number_cont: null,
				ordered_product_product_product_category_id_eq: null,
				ordered_product_product_name_cont: null,
			},
		}
	},
	mounted() {
		this.q = this.query
	},
	methods: {
		searchOrderIndividualInfos() {
			this.$emit("search-infos", this.q)
			this.dialog = false
		},
		resetForm() {
			this.$refs.form.reset()
		},
		changeDateRange(dateRange, queryName) {
			if (this[dateRange].length) {
				const firstDate = this[dateRange][0]
				const lastDate = this[dateRange][this[dateRange].length - 1]
				if (firstDate > lastDate) {
					this.q[`${queryName}_gteq`] = lastDate
					this.q[`${queryName}_lteq`] = firstDate
				} else {
					this.q[`${queryName}_gteq`] = firstDate
					this.q[`${queryName}_lteq`] = lastDate
				}
			} else {
				this.q[`${queryName}_gteq`] = null
				this.q[`${queryName}_lteq`] = null
			}
			this.$refs[`${dateRange}Menu`].save(this[dateRange])
		},
	},
	computed: {
		plannedShippingDatesText: {
			get() {
				return this.plannedShippingDateRange.length
					? this.plannedShippingDateRange.map((d) => common.formatDate(d)).join(" ~ ")
					: null
			},
			set(newVal) {
				this.plannedShippingDateRange = []
				this.changeDateRange("plannedShippingDateRange", "delivery_info_planned_shipping_date")
				return
			},
		},
	},
	watch: {
		query: {
			handler(val) {
				this.q = val
			},
			deep: true,
		},
	},
}
</script>
